import React from 'react';

// Lehká, čistě CSS dekorace pro různé roční období / svátky.
// Žádné runtime knihovny, fixed position, pointer-events-none.

const Snowflake = ({ left, delay, size, duration }) => (
  <span
    className="absolute top-[-20px] text-white/80 select-none pointer-events-none animate-snowfall"
    style={{ left: `${left}%`, animationDelay: `${delay}s`, fontSize: size, animationDuration: `${duration}s` }}
    aria-hidden="true"
  >❄</span>
);

const FloatingEmoji = ({ left, delay, size, duration, char, opacity = 0.6 }) => (
  <span
    className="absolute bottom-[-40px] select-none pointer-events-none animate-floatup"
    style={{ left: `${left}%`, animationDelay: `${delay}s`, fontSize: size, animationDuration: `${duration}s`, opacity }}
    aria-hidden="true"
  >{char}</span>
);

const seeded = (n) => Array.from({ length: n }, (_, i) => ({
  left: (i * 37 + 7) % 100,
  delay: (i * 1.3) % 12,
  duration: 8 + ((i * 7) % 10),
  size: `${1 + ((i * 3) % 5) * 0.3}rem`
}));

const Christmas = () => (
  <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden" data-testid="theme-christmas">
    {seeded(28).map((s, i) => <Snowflake key={i} {...s} />)}
  </div>
);

const Easter = () => (
  <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden" data-testid="theme-easter">
    {seeded(14).map((s, i) => (
      <FloatingEmoji key={i} {...s} char={['🐰', '🥚', '🌷', '🐣'][i % 4]} opacity={0.7} />
    ))}
  </div>
);

const Summer = () => (
  <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden" data-testid="theme-summer">
    {seeded(14).map((s, i) => (
      <FloatingEmoji key={i} {...s} char={['🌻', '🦋', '🌞', '🍓'][i % 4]} opacity={0.6} />
    ))}
  </div>
);

const Autumn = () => (
  <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden" data-testid="theme-autumn">
    {seeded(20).map((s, i) => (
      <Snowflake key={i} {...s} />
    ))}
  </div>
);

const Spring = () => (
  <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden" data-testid="theme-spring">
    {seeded(14).map((s, i) => (
      <FloatingEmoji key={i} {...s} char={['🌸', '🌼', '🐝', '🌷'][i % 4]} opacity={0.7} />
    ))}
  </div>
);

const Valentines = () => (
  <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden" data-testid="theme-valentines">
    {seeded(14).map((s, i) => (
      <FloatingEmoji key={i} {...s} char={'❤'} opacity={0.7} />
    ))}
  </div>
);

const Halloween = () => (
  <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden" data-testid="theme-halloween">
    {seeded(14).map((s, i) => (
      <FloatingEmoji key={i} {...s} char={['🎃', '🦇', '👻', '🕷'][i % 4]} opacity={0.7} />
    ))}
  </div>
);

// Autumn — listí
const AutumnLeaves = () => (
  <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden" data-testid="theme-autumn-leaves">
    {seeded(18).map((s, i) => (
      <span
        key={i}
        className="absolute top-[-20px] select-none animate-snowfall"
        style={{ left: `${s.left}%`, animationDelay: `${s.delay}s`, fontSize: s.size, animationDuration: `${s.duration + 3}s`, opacity: 0.8 }}
        aria-hidden="true"
      >{['🍁', '🍂', '🍄'][i % 3]}</span>
    ))}
  </div>
);

export const SeasonalDecorations = ({ theme }) => {
  if (!theme || theme === 'none') return null;
  switch (theme) {
    case 'christmas': return <Christmas />;
    case 'easter': return <Easter />;
    case 'summer': return <Summer />;
    case 'autumn': return <AutumnLeaves />;
    case 'spring': return <Spring />;
    case 'valentines': return <Valentines />;
    case 'halloween': return <Halloween />;
    default: return null;
  }
};

export const THEME_OPTIONS = [
  { key: 'none', label: 'Žádný motiv', emoji: '🚫' },
  { key: 'christmas', label: 'Vánoce', emoji: '🎄' },
  { key: 'easter', label: 'Velikonoce', emoji: '🐰' },
  { key: 'spring', label: 'Jaro', emoji: '🌸' },
  { key: 'summer', label: 'Léto', emoji: '🌞' },
  { key: 'autumn', label: 'Podzim', emoji: '🍁' },
  { key: 'valentines', label: 'Sv. Valentýn', emoji: '❤️' },
  { key: 'halloween', label: 'Halloween', emoji: '🎃' }
];

export default SeasonalDecorations;
